import {
	confirmSalesMonitorError,
	confirmSalesMonitorSuccess,
	getSalesMonitorItemsSuccess,
	getZonesSuccess,
	selectSalesMonitorError,
	selectSalesMonitorSuccess,
	validateBarCodeMonitorError,
	validateBarCodeMonitorSuccess
} from 'actions'
import {
	confirmSalesMonitorApi,
	getSalesMonitorItemsApi,
	getZonesApi,
	selectSalesMonitorApi,
	validateBarCodeMonitorApi
} from 'api/SalesMonitor'
import { SalesMonitorActions } from 'constants/ActionsTypesTs'
import {
	IConfirmSalesMonitorAction,
	IConfirmSalesMonitorResponse,
	IGetSalesMonitorItemsAction,
	IGetSalesMonitorItemsResponse,
	IGetZonesResponse,
	ISelectSalesMonitorAction,
	ISelectSalesMonitorResponse,
	IValidateBarCodeMonitorAction,
	IValidateBarCodeMonitorResponse
} from 'models/SalesMonitor'
import { all, call, fork, put, takeEvery } from 'redux-saga/effects'

function* getZonesRequest(): any {
	try {
		const zones: IGetZonesResponse = yield call(getZonesApi)
		yield put(getZonesSuccess(zones))
	} catch (error) {}
}

function* getSalesMonitorItemsRequest({
	payload
}: IGetSalesMonitorItemsAction): any {
	try {
		const items: IGetSalesMonitorItemsResponse = yield call(
			getSalesMonitorItemsApi,
			payload
		)
		yield put(getSalesMonitorItemsSuccess(items))
	} catch (error) {}
}

function* confirmSalesMonitorRequest({
	payload
}: IConfirmSalesMonitorAction): any {
	try {
		const { values, callBackReturn } = payload
		const items: IConfirmSalesMonitorResponse = yield call(
			confirmSalesMonitorApi,
			values
		)
		if (callBackReturn) {
			callBackReturn()
		}
		yield put(confirmSalesMonitorSuccess(items))
	} catch (error: any) {
		const { Resultado, Message } = error.response.data
		const errorMessage =
			Resultado && !Resultado.Resultado ? Resultado.Mens_error : Message || ''

		yield put(
			confirmSalesMonitorError({ message: errorMessage, confirm: true })
		)
	}
}

function* selectSalesMonitorRequest({
	payload
}: ISelectSalesMonitorAction): any {
	try {
		const items: ISelectSalesMonitorResponse = yield call(
			selectSalesMonitorApi,
			payload
		)
		yield put(selectSalesMonitorSuccess(items))
	} catch (error: any) {
		const { Resultado } = error.response.data
		const errorMessage = !Resultado.Resultado ? Resultado.Mens_error : ''
		yield put(
			selectSalesMonitorError({ message: errorMessage, confirm: false })
		)
	}
}

function* validateBarCodeMonitorRequest({
	payload
}: IValidateBarCodeMonitorAction): any {
	try {
		const items: IValidateBarCodeMonitorResponse = yield call(
			validateBarCodeMonitorApi,
			payload
		)
		yield put(validateBarCodeMonitorSuccess(items))
	} catch (error: any) {
		const { Resultado } = error.response.data
		const errorMessage = !Resultado.Resultado ? Resultado.Mens_error : ''
		yield put(validateBarCodeMonitorError({ message: errorMessage }))
	}
}

export function* getZonesSaga() {
	yield takeEvery(SalesMonitorActions.GET_ZONES, getZonesRequest)
}

export function* getSalesMonitorItemsSaga() {
	yield takeEvery(
		SalesMonitorActions.GET_SALES_MONITOR_ITEMS,
		getSalesMonitorItemsRequest
	)
}

export function* confirmSalesMonitorSaga() {
	yield takeEvery(
		SalesMonitorActions.CONFIRM_SALES_MONITOR,
		confirmSalesMonitorRequest
	)
}

export function* selectSalesMonitorSaga() {
	yield takeEvery(
		SalesMonitorActions.SELECT_SALES_MONITOR_ITEMS,
		selectSalesMonitorRequest
	)
}

export function* validateBarCodeMonitorSaga() {
	yield takeEvery(
		SalesMonitorActions.VALIDATE_BAR_CODE_MONITOR,
		validateBarCodeMonitorRequest
	)
}

export default function* rootSaga() {
	yield all([
		fork(getZonesSaga),
		fork(getSalesMonitorItemsSaga),
		fork(confirmSalesMonitorSaga),
		fork(selectSalesMonitorSaga),
		fork(validateBarCodeMonitorSaga)
	])
}
